export default "__VITE_ASSET__64fb78ad__"